import React, { createContext, useState, useContext } from 'react';
import { LinearProgress } from '@mui/material';

interface IProgressContextData {
  isLoad: boolean;
  setLoad(load: boolean): void;
}

const ProgressContext = createContext<IProgressContextData>(
  {} as IProgressContextData,
);

const ProgressProvider: React.FC = ({ children }) => {
  const [isLoad, setLoad] = useState(false);

  return (
    <ProgressContext.Provider
      value={{
        isLoad,
        setLoad,
      }}
    >
      {isLoad && (
        <div style={{ position: 'fixed', zIndex:999, top: 0, left: 0, right: 0 }}>
          <LinearProgress 
          sx={{backgroundColor: `#A2A4FF`,
          "& .MuiLinearProgress-bar": {
            backgroundColor: `#6C5AF4`
          }
  }}/>
        </div>
      )}
      {children}
    </ProgressContext.Provider>
  );
};

function useProgress(): IProgressContextData {
  const context = useContext(ProgressContext);

  if (!context) {
    throw new Error('useProgress must be used within an ProgressProvider');
  }

  return context;
}

export { ProgressProvider, useProgress };